import { ReportsListComponent } from './reports/components/reports-list/reports-list.component';
import { MyApprovalsComponent } from './reports/components/my-approvals/my-approvals.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CalGuardService } from '@cvx/cal-angular';
import { ReportFormComponent } from './reports/components/report-form/report-form.component';
import { ActionItemListComponent } from './action-items/components/list/action-item-list.component';
import { ActionItemCreateComponent } from './action-items/components/create/action-item-create.component';
import { reportFormResolver } from './resolvers/report-form.resolver';
import { actionItemResolver } from './resolvers/action-item.resolver';
import { policyGuard } from './reports/services/roles/policy-guard';

const routes: Routes = [
  { path: '', redirectTo: '/reports', pathMatch: 'full' },
  {
    path: 'reports',
    canActivate: [CalGuardService],
    children: [
      { path: '', component: ReportsListComponent },
      { path: 'add', component: ReportFormComponent, canActivate: [policyGuard] },
      {
        path: ':id',
        component: ReportFormComponent,
        canActivate: [policyGuard],
        resolve: {
          id: reportFormResolver
        }
      },
       {
        path: 'action-items',
        resolve: {
          id: actionItemResolver
        },
        children: [
          { path: 'create', component: ActionItemCreateComponent },
          { path: 'edit/:id', component: ActionItemCreateComponent },
        ],
      },
    ],
  },
  {
    path: 'action-items',
    canActivate: [CalGuardService],
    children: [
      { path: '', component: ActionItemListComponent },
      // { path: 'create', component: ActionItemCreateComponent },
      {
        path: 'edit/:id',
        component: ActionItemCreateComponent,
      }
    ],
  },
  {
    path: 'my-approvals',
    canActivate: [CalGuardService],
    children: [
      { path: '', component: MyApprovalsComponent },
      { path: 'add', component: ReportFormComponent, canActivate: [policyGuard] },
      {
        path: ':id',
        component: ReportFormComponent,
        canActivate: [policyGuard],
        resolve: {
          id: reportFormResolver
        }
      },
      {
        path: 'action-items',
        resolve: {
          id: actionItemResolver
        },
        children: [
          { path: 'create', component: ActionItemCreateComponent },
          { path: 'edit/:id', component: ActionItemCreateComponent },
        ],
      },
    ],
  },
  {
    path: 'damage-mechanisms',
    canActivate: [CalGuardService],
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './damage-mechanisms/components/list/list-damage-mechanisms.component'
          ).then((c) => c.DamageMechanismsComponent),
        pathMatch: 'full',
      },
      {
        path: 'create',
        loadComponent: () =>
          import(
            './damage-mechanisms/components/create/create-damage-mechanisms.component'
          ).then((c) => c.CreateDamageMechanismsComponent),
      },
      {
        path: 'edit/:id',
        loadComponent: () =>
          import(
            './damage-mechanisms/components/create/create-damage-mechanisms.component'
          ).then((c) => c.CreateDamageMechanismsComponent),
        data: { editing: true },
      },
    ],
  },
  {
    path: 'facility-owners',
    canActivate: [CalGuardService],
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './facility-owners/components/list/list-facility-owners.component'
          ).then((c) => c.ListFacilityOwnersComponent),
        pathMatch: 'full',
      },
      {
        path: 'create',
        loadComponent: () =>
          import(
            './facility-owners/components/create/create-facility-owners.component'
          ).then((c) => c.CreateFacilityOwnersComponent),
      },
      {
        path: 'edit/:id',
        loadComponent: () =>
          import(
            './facility-owners/components/create/create-facility-owners.component'
          ).then((c) => c.CreateFacilityOwnersComponent),
        data: { editing: true },
      },
    ],
  },{
    path: 'distribution-list',
    canActivate: [CalGuardService],
    children: [
      {
        path: '',
        loadComponent: () =>
          import(
            './distribution-list/components/list/list-distribution-list.component'
          ).then((c) => c.ListDistributionListComponent),
        pathMatch: 'full',
      },
      {
        path: 'create',
        loadComponent: () =>
          import(
            './distribution-list/components/create/create-distribution-list.component'
          ).then((c) => c.CreateDistributionListComponent),
      },
      {
        path: 'edit/:id',
        loadComponent: () =>
          import(
            './distribution-list/components/create/create-distribution-list.component'
          ).then((c) => c.CreateDistributionListComponent),
        data: { editing: true },
      },
    ],
  },
  {
    path: '*',
    redirectTo: '/reports'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
